export type SessionInfo = {
  name: string;
  id: string;
  signature: string;
};

/**
 * Attach session information (name + signed id) to a URL so that the server
 * can reconstruct the Symfony session even when cookies are not forwarded
 * (e.g. inside an embedded iframe in browsers with strict SameSite rules).
 *
 * Legacy behaviour replicated from window.hellofaxJS.attachSessionInfoToUrl
 * but rewritten in TypeScript so it can be imported without relying on the
 * global helper.
 */
export function appendSessionInfo(url: string): string {
  const info = (window as any).sessionInfo as SessionInfo | undefined;
  if (!info || !info.name || !info.id || !info.signature) {
    return url;
  }

  // Do not append if the parameter already exists in the URL.
  if (url.includes(`${encodeURIComponent(info.name)}=`)) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${encodeURIComponent(info.name)}=${encodeURIComponent(`${info.id}:${info.signature}`)}`;
}
